<template>
    <select v-model="selectedTime"
            :name="name"
            @change="onChange($event)" 
            class="form-control form-control-lg taurus-timepicker">
        <option value="" disabled selected>HH:MM</option>
        <option
            v-for=" (interval, index) in timeIntervals"
            :key="index"
            :value="interval">
            {{interval}}
        </option>
    </select>
</template>
<script>

export default {

  props: {
    value: { required: false },
    hour_format: { required: false, type: String, default: '24' },
    validationRule: {
      type: String
    },
    name: String
  },
  data: () => {
    return {
      selectedTime: null,
      timeIntervals: []
    }
  },
  mounted () {
    if (this.hour_format == '24') {
      for (let i = 0; i < 24; i++) {
        let hr = i < 10 ? '0' + i : i

        this.timeIntervals.push(hr + ':00')
        this.timeIntervals.push(hr + ':30')
      }
    } else {
      let suffix = ['AM', 'PM']

      for (let i = 0; i < suffix.length; i++) {
        for (let j = 0; j < 12; j++) {
          let hr = j < 10 ? '0' + j : j
          if (hr == '00') {
            hr = '12'
          }

          this.timeIntervals.push(hr + ':00 ' + suffix[i])
          this.timeIntervals.push(hr + ':30 ' + suffix[i])
        }
      }
    }
    this.selectedTime = this.value
  },
  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

